import React, { useContext, useEffect, useRef, useState } from 'react'
import { Divider, Grid, TextField, Typography, Paper, Box } from '@material-ui/core';
import { backGroundList } from '../../../../constants/globalConst';
import { UserContext } from '../../../../context/UserProvider';
import moment from 'moment';
import UpdatingButton from './ConfigComponents/UpdatingButton';
import DialogConfirm from './ConfigComponents/DialogConfirm';
import { db } from '../../../../config/firebase';
import { ConfigWaterLevel } from './ConfigNodeComponents/ConfigWaterLevel';

const allParameters = [
  { id: "conductivity", alias: "Conductividad(EC)" },
  { id: "temperature", alias: "Temperatura" },
  { id: "ph", alias: "pH" },
  { id: "humidity", alias: "Humedad" },
  { id: "pressure", alias: "Presión" },
  { id: "co2", alias: "CO2" },
  { id: "nitrogen", alias: "Nitrógeno" },
  { id: "phosphorus", alias: "Fósforo" },
  { id: "potassium", alias: "Potasio" },
  { id: "photosynthetic", alias: "Fotosistencia(PAR)" },
  { id: "windSpeed", alias: "Velocidad del viento" },
  { id: "rainGauge", alias: "Lluvia" },
  { id: "pm2.5", alias: "PM2.5" },
  { id: "pm10", alias: "PM10" },
  { id: "noise", alias: "Ruido" },
  { id: "rainfall", alias: "Lluvia" },
  { id: "salinity", alias: "Salinidad" },
]


export const ConfigLoraWanNode = (propiedades) => {
  const data = propiedades.data;
  const ide = data.ide;
  const arrayDeCadenas = ide.split("@");
  const typeOfSensor = arrayDeCadenas[3];
  //const nodeNumber = arrayDeCadenas[3];
  const macId = arrayDeCadenas[0];
  const { usuario, userTimezone } = useContext(UserContext);
  const [error, setError] = useState(null);
  const [openWindow, setOpenWindow] = useState(false);
  const [newName, setNewName] = useState('');
  const [nodeNumber, setNodeNumber] = useState("");
  const [lastUpdate, setLastUpdate] = useState("");
  const [nameDataSaved, setNameDataSaved] = useState([]);
  const [offsetParameters, setOffsetParameters] = useState([])
  const [dataConfig, setDataConfig] = useState({
    nodeName: "-",
    nodeId: "-",
    fecha: "-",
    offset_values: ["-", "-", "-", "-", "-", "-", "-"],
    offset_signs: ["0", "0", "0", "0", "0", "0", "0"],
  });
  // Referencia para exponer la función de guardado del hijo
  const containerDataFormRef = useRef(null);

  const handleNameChange = (e) => {
    setNewName(e.target.value);
  };

  const editar = async (e) => {
    e.preventDefault();

    if (!newName.trim()) {
      setError("Ingrese Nombre");
      return;
    }
    setError(null);

    setOpenWindow(true);
  };

  const agreeDialog = async () => {

    //setLoading(true)
    try {
      const arrayDeCadenas = ide.split("@");
      const nodeId = arrayDeCadenas[2];
      const sensorId = arrayDeCadenas[4];
      const savePath = `${usuario.username}/loraDevices/nodes/${nodeId}/namesOfCards`;
      const docRef = db.collection(savePath).doc("names");

      const allNames = [...nameDataSaved];
      allNames.forEach((element) => {
        if (element.id === Number(sensorId)) {
          element.lastUpdate = new Date().toUTCString();
          element.name = newName;
        }
      })

      // const nameObject = nameDataSaved.find(
      //   (element) => element.id === Number(typeSensor)
      // );
      // nameObject.name = newName;
      // nameObject.lastUpdate = new Date().toUTCString();
      await docRef.set({ allNames })

      if (typeOfSensor === "14" || typeOfSensor === "15" || typeOfSensor === "24") {
        await handleSaveWaterContainerData()
      }

      if (offsetParameters && offsetParameters.length > 0) {
        const sensorsDocRef = db.collection(`${usuario.username}/loraDevices/nodes/${nodeId}/sensors`).doc("registeredSensors");
        const sensorsDocSnap = await sensorsDocRef.get();

        if (sensorsDocSnap.exists) {
          let sensorsArray = sensorsDocSnap.data().sensors || [];
          const sensorIndex = sensorsArray.findIndex(element => element.id === Number(sensorId));

          if (sensorIndex !== -1) {
            let currentOffsets = { ...sensorsArray[sensorIndex].offsets };

            let ecDivider = 1;
            let ecLabel = "uS/cm";
            try {
              const userFromLocal = JSON.parse(localStorage.getItem("usuario"));
              if (userFromLocal && userFromLocal.ecUnits && userFromLocal.ecUnits.divider) {
                ecDivider = userFromLocal.ecUnits.divider;
                ecLabel = userFromLocal.ecUnits.label;
              }
            } catch (e) {
              console.error(e);
            }

            offsetParameters.forEach(param => {
              if (param.value !== "" && param.value !== undefined && param.value !== null) {
                let numVal = parseFloat(param.value);
                if (!isNaN(numVal) && numVal !== 0) {
                  if (param.nameId === 'conductivity') {
                    numVal = ecLabel !== "ppm" ? numVal * ecDivider : numVal / ecDivider; // Guardamos convertido a uS
                  }
                  currentOffsets[param.nameId] = numVal;
                } else {
                  delete currentOffsets[param.nameId];
                }
              } else {
                delete currentOffsets[param.nameId];
              }
            });

            sensorsArray[sensorIndex].offsets = currentOffsets;
            await sensorsDocRef.set({ sensors: sensorsArray }, { merge: true });
          }
        }
      }

      //const item = { ...dataConfig, fecha: Date.now(), nodeName: newName ,uid: ide };
      //   const addr = `${usuario.username}/loraDevices/nodes/${nodeNumber}/configNode`;

      //   await db.collection(addr).doc("renderData").set({ item });

      //Envio de datos por MQTT
      //   for (let index = 0; index < arraySensorsData.length; index++) {
      //     procesarDatosSecuencialmente([arraySensorsData[index]]);
      //   }

      //Reset of values that changed
      //   for (let index = 0; index < arraySensorsData.length; index++) {
      //     arraySensorsData[index].changed = false;
      //   } 

      //setDataConfig({...dataConfig, nodeName: newName});
      setOpenWindow(false);
    } catch (error) {
      console.log(error);
    }
  };

  // Llamamos a la función de guardado del hijo (expuesta vía forwardRef)
  const handleSaveWaterContainerData = async () => {
    if (containerDataFormRef.current) {
      await containerDataFormRef.current.saveContainerData();
    }
  };

  const handleChangeOffset = (e, index) => {
    const { value } = e.target;
    const updatedParameters = offsetParameters.map((item, idx) => {
      if (idx === index) {
        return { ...item, value: value };
      }
      return item;
    });
    setOffsetParameters(updatedParameters);
  };

  useEffect(() => {
    let isMounted = true; // Bandera para verificar si el componente está montado

    const obtenerDatos = async () => {
      try {
        const arrayDeCadenas = ide.split("@");
        const nodeId = arrayDeCadenas[2];
        const typeSensor = arrayDeCadenas[3];
        const sensorId = arrayDeCadenas[4];

        const addr = `${usuario.username}/loraDevices/nodes/${nodeId}/namesOfCards`;
        const addr2 = `${usuario.username}/loraDevices/nodes/${nodeId}/sensors`;
        const nodesAddr = `${usuario.username}/loraDevices/nodes`;

        const leerDatosDB = async () => {
          try {
            const docRef = db.collection(addr).doc("names");
            const docSnap = await docRef.get();

            const nodeNumDoc = await db.collection(nodesAddr).doc(nodeId).get();

            if (docSnap.exists && nodeNumDoc.exists) {
              const dataItem = docSnap.data().allNames;
              const nodeNumberObtained = nodeNumDoc.data().node;
              const currentName = dataItem.find(
                (element) => element.id === Number(sensorId)
              );

              let matchedParameters = [];
              const docSnapDataSensors = await db.collection(addr2).doc("dataSensors").get();
              if (docSnapDataSensors.exists && (typeSensor !== "14" && typeSensor !== "15" && typeSensor !== "12")) {
                const dataArray = docSnapDataSensors.data().data;
                const cardData = dataArray?.find(item => item.id === Number(sensorId));
                if (cardData) {
                  const relevantKeys = Object.keys(cardData).filter(key => allParameters.some(p => p.id === key));

                  let existingOffsets = {};
                  const docSnapRegisteredSensors = await db.collection(addr2).doc("registeredSensors").get();
                  if (docSnapRegisteredSensors.exists) {
                    const sensorsArray = docSnapRegisteredSensors.data().sensors || [];
                    const foundSensor = sensorsArray.find(element => element.id === Number(sensorId));
                    if (foundSensor && foundSensor.offsets) {
                      existingOffsets = foundSensor.offsets;
                    }
                  }

                  let ecDivider = 1;
                  try {
                    const userFromLocal = JSON.parse(localStorage.getItem("usuario"));
                    if (userFromLocal && userFromLocal.ecUnits && userFromLocal.ecUnits.divider) {
                      ecDivider = userFromLocal.ecUnits.divider;
                    }
                  } catch (e) {
                    console.error(e);
                  }

                  matchedParameters = relevantKeys.map(key => {
                    const foundAlias = allParameters.find(element => element.id === key);
                    let initialValue = existingOffsets[key] !== undefined ? existingOffsets[key] : "0";

                    if (key === 'conductivity' && initialValue !== "0") {
                      initialValue = parseFloat(initialValue) / ecDivider; // Convertimos de uS a la unidad del usuario
                      const decimalPointsLength = initialValue.toString().split('.')[1]?.length || 0;
                      if (decimalPointsLength > 3) initialValue = Number(initialValue.toFixed(3));
                    }

                    return {
                      nameId: key,
                      alias: foundAlias ? foundAlias.alias : key,
                      value: initialValue
                    }
                  }).sort((a, b) => a.alias.localeCompare(b.alias));
                }
              }

              if (isMounted) {
                setNewName(currentName?.name); // Usa opcional chaining para evitar errores
                setNodeNumber(nodeNumberObtained);
                setLastUpdate(currentName?.lastUpdate);
                setNameDataSaved([...dataItem]);
                setOffsetParameters(matchedParameters)
              }
            } else {
              console.log("No se encontró el documento!");
            }
          } catch (error) {
            console.error("Error al obtener el documento:", error);
          }
        };

        await leerDatosDB();
      } catch (error) {
        console.error("Error en obtenerDatos:", error);
      }
    };

    obtenerDatos();

    return () => {
      isMounted = false; // Marca como desmontado en la limpieza
    };
  }, [ide, usuario.username]);

  return (
    <>
      <div className="container mt-3">
        <form onSubmit={editar}>
          <div className="row">
            <div className="col-12">
              <ul className="list-group">
                <li
                  className="list-group-item"
                  style={{ background: backGroundList }}
                >
                  <div className="row">
                    <div className=" col-10">
                      <h4 style={{ color: "white" }}>{newName}</h4>
                    </div>
                  </div>
                </li>
                <li className="list-group-item">

                  <div className="row">
                    <div className="col-6">Número de Nodo:</div>
                    <div className="col-6">{nodeNumber}</div>
                  </div>

                  <div className="row">
                    <div className="col-6">Nombre:</div>
                    <div className="col-6">
                      <input
                        type="text"
                        placeholder="Ingrese Nombre"
                        className="form-control mb-2"
                        onChange={handleNameChange}
                        value={newName}
                      ></input>
                    </div>
                  </div>

                  {dataConfig.fecha && (
                    <div className="row">
                      <div className="col-6">Última modificación:</div>
                      <div className="col-6">
                        {/* {moment(comp.fecha).format("llll")} */}
                        {/* {new Date(dataConfig.fecha).toString()} */}
                        {moment(lastUpdate).tz(userTimezone).format('ddd, D [de] MMM [de] YYYY, HH:mm [Hrs.]')}
                      </div>
                    </div>
                  )}

                  <div style={{ marginTop: '15px' }}>
                    <Divider />
                  </div>

                  {(typeOfSensor === "14" || typeOfSensor === "15" || typeOfSensor === "24") && (
                    <ConfigWaterLevel
                      ref={containerDataFormRef}
                      username={usuario.username}
                      nodeId={ide.split("@")[2]}
                      typeSensor={ide.split("@")[3]}
                      sensorId={ide.split("@")[4]}
                    />
                  )}
                  {/* Offset Aqui */}
                  {offsetParameters?.length > 0 && (
                    <Box mt={3} mb={3}>
                      <Paper elevation={3} style={{ padding: '24px', borderRadius: '12px', backgroundColor: '#fafafa', border: '1px solid #e0e0e0' }}>
                        <Typography variant="h6" style={{ marginBottom: '16px', color: '#333', fontWeight: '600' }}>
                          Ajuste de Offsets
                        </Typography>
                        <Divider style={{ marginBottom: '24px' }} />
                        <Typography variant="body2" color="textSecondary" style={{ marginBottom: '20px' }}>
                          Puede agregar el signo (-) para indicar resta; sin signo se toma como suma (+). Se aceptan hasta 3 decimales.
                        </Typography>
                        <Grid container spacing={4}>
                          {offsetParameters?.map((item, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                              <TextField
                                id={`input_${index}`}
                                name={item.nameId}
                                label={item.alias}
                                type="number"
                                variant="outlined"
                                size="small"
                                fullWidth
                                value={item.value}
                                onChange={(e) => handleChangeOffset(e, index)}
                                inputProps={{
                                  step: "0.001",
                                }}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Paper>
                    </Box>
                  )}

                </li>
              </ul>
            </div>
          </div>

          <div className="row ">
            {
              //como operador ternario
              error && (
                <div className="col-12 mt-3">
                  <div className="alert alert-danger alert-block">{error}</div>
                </div>
              )
            }
          </div>

          <UpdatingButton type="submit" disabled={false} />
        </form>


      </div>
      <DialogConfirm
        open={openWindow}
        handleClose={() => setOpenWindow(false)}
        agreeDialog={agreeDialog}
        title={"¿Está seguro que quiere continuar con esta operación?"}
        text={
          "Se realizará un cambio en el nombre de la tarjeta de información del Nodo."
        }
      />

    </>
  )
}
